import Api from '@/services/Api'

const resource = 'catalogo'

export default {
  getCatNivelEstudios() {
    return Api().get(`${resource}/nivelestudios/cat`)
  },
  getCatGenero() {
    return Api().get(`${resource}/sexo/cat`)
  },
  getCatEstatusSolicitud() {
    return Api().get(`${resource}/estatussolicitud/cat`)
  },
  getCatEstatusBecario() {
    return Api().get(`${resource}/estatusbecario/cat`)
  },
  getCatConvocatoria() {
    return Api().get(`${resource}/tipoconvocatoria/cat`)
  },
  getCatExperiencia() {
    return Api().get(`${resource}/experienciaanterior/cat`)
  },
  getCatEstadoCivil() {
    return Api().get(`${resource}/estadocivil/cat`)
  },
  // CATALOGOS PUBLICOS
  getCatPubNivelEstudios() {
    return Api().get(`${resource}/nivelestudios/catp`)
  },
  getCatPubGenero() {
    return Api().get(`${resource}/sexo/catp`)
  },
  getCatPubConvocatoria() {
    return Api().get(`${resource}/tipoconvocatoria/catp`)
  },
  getCatPubExperiencia() {
    return Api().get(`${resource}/experienciaanterior/catp`)
  },
  getCatPubDocumentos() {
    return Api().get(`${resource}/tipodocumentos/catp`)
  },
  getCatPubEstadoCivil() {
    return Api().get(`${resource}/estadocivil/catp`)
  },
  getCatPubNacionalidad() {
    return Api().get(`${resource}/nacionalidad/catp`)
  },
  getCatPubComprobandeEstudios() {
    return Api().get(`${resource}/comprobanteestudios/catp`)
  },
  // getCatPubConvocatoriaDocumentos(form) {
  //   return Api().post(`${resource}/convocatoriadocumentos/catp`, form)
  // },
  getCatPubTallas() {
    return Api().get(`${resource}/tallas/catp`)
  },
  getCatPubTallasCalzado() {
    return Api().get(`${resource}/tallascalzado/catp`)
  },
  // CONVOCATORIAS - DOCUMENTOS
  getCatPubConvocatoriaDocumento(convocatoria) {
    return Api().post(`${resource}/convocatoriadocumentos/catp`, convocatoria)
  },
  getConvByUser(params) {
    return Api().get(`${resource}/usuarios-convocatorias`, { params })
  },
  // CATALOGO - CAMBIOS
  getCatPubMedioinformacion() {
    return Api().get(`${resource}/medioinformacion/catp`)
  },
  getCatPubComunidadafrodescendiente() {
    return Api().get(`${resource}/comunidadafrodescendientes/catp`)
  },
  getCatPubComunidadindigena() {
    return Api().get(`${resource}/comunidadindigena/catp`)
  },
  getCatPubComunidadlgbttti() {
    return Api().get(`${resource}/comunidadlgbttti/catp`)
  },
}
